export default {
      id: "planner-plus-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-plus",
      toString: function () {
        return this.url;
      }
    }